import config from 'config/appConfig';
import { DivConst } from 'constants/divConst';
import { DivClassType } from 'types/divClassType';

export class AppHelper {
  /* ----------------------------------------------------------------------- */
  /* Validation関連 */
  /* ----------------------------------------------------------------------- */
  /**
   * 値の存在検証をします。
   */
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  static isEmpty(input: any): boolean {
    if (input === null || input === undefined) {
      return true;
    } else if (input === '') {
      return true;
    } else if (Array.isArray(input) && input.length === 0) {
      return true;
    } else if (typeof input === 'object' && Object.keys(input).length === 0) {
      return true;
    }
    return false;
  }

  /**
   * 値の存在検証をします。
   */
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  static isNotEmpty(input: any): boolean {
    return !this.isEmpty(input);
  }

  /**
   * URLフォーマットの検証をします。
   */
  static isUrl(input: string) {
    let url;
    try {
      url = new URL(input);
    } catch (_) {
      return false;
    }
    return url.protocol === 'http:' || url.protocol === 'https:';
  }

  /* ----------------------------------------------------------------------- */
  /* 区分定数関連 */
  /* ----------------------------------------------------------------------- */
  /**
   * 区分値のラベルを取得します。
   */
  static getDivLabel(divClass: DivClassType, value: number): string {
    const entry = Object.values(DivConst.items[divClass]).find(item => item.value === value);
    return entry.label ?? '';
  }
  /**
   * 区分値の存在検証をします。
   */
  static isDivValue(divClass: DivClassType, value: number): boolean {
    return Object.values(DivConst.items[divClass]).some(v => v.value === value);
  }
  /**
   * 選択オプション用の区分値の配列を返します。
   */
  static getDivSelectOptions(divClass: DivClassType): { value: string; label: string }[] {
    return Object.values(DivConst.items[divClass]).map(item => ({
      value: item.value.toString(),
      label: item.label,
    }));
  }

  /* ----------------------------------------------------------------------- */
  /* 画面制御関連 */
  /* ----------------------------------------------------------------------- */
  /**
   * 二重送信を防止します。
   */
  static async submit(
    processing: boolean,
    setProcessing: (processing: boolean) => void,
    callback: { (): Promise<void> }
  ): Promise<void> {
    if (processing) {
      return;
    }
    setProcessing(true);
    await callback();
    setProcessing(false);
    return;
  }

  /* ----------------------------------------------------------------------- */
  /* 画面表示関連 */
  /* ----------------------------------------------------------------------- */
  /**
   * S3の画像パスをCDNのURLに変換します。
   */
  static getImageUrl(imageKey: string | null): string {
    if (!imageKey) {
      return null;
    }
    return `${config.s3.bucket.staticContents.endpoint}${imageKey.replace('public/', '/')}`;
  }

  /* ----------------------------------------------------------------------- */
  /* 画面フォーマット関連 */
  /* ----------------------------------------------------------------------- */
  /**
   * 割合をパーセント表示にします。
   * 第二引数が指定された場合は。第一引数と第二引数を除算した値のパーセント表示にします。
   */
  static formatRateToPercent(numerator: number, denominator?: number): number {
    if (numerator == null) {
      return null;
    }
    // 第二引数が指定された場合は。第一引数と第二引数を除算した値のパーセント表示にします。
    const denominatorVal = denominator ?? 1;
    const rate = numerator && denominatorVal ? numerator / denominatorVal : 0;

    // 小数点以下を四捨五入して整数にする
    return Math.round(rate * 100);
  }

  /* ----------------------------------------------------------------------- */
  /* 共通ユーティリティ */
  /* ----------------------------------------------------------------------- */
  /**
   * クイズのデザインテンプレートIDに対応するクラス名を返します。
   */
  static getDesignClassName(quizTemplateId: number): string {
    console.log('quizTemplateId', quizTemplateId);
    if (quizTemplateId == 1) {
      return 'quiz-home-light-blue';
    }
    if (quizTemplateId == 2) {
      return 'quiz-home-pink';
    }
    if (quizTemplateId == 3) {
      return 'quiz-home-gray';
    }
    if (quizTemplateId == 4) {
      return 'quiz-home-caro-blue';
    }
    return '';
  }
}
